import { put, call } from 'redux-saga/effects';
import {
    GetEmployeeFamilyHelper,
    AddEmployeeFamilyHelper,
    DeleteEmployeeFamilyHelper,
    UpdateEmployeeFamilyHelper,
    GetEmployeeBasicHelper,
    AddEmployeeBasicHelper,
    UpdateEmployeeBasicHelper,
    AddEmployeeBankHelper,
    UpdateEmployeeBankHelper,
    DeleteEmployeeBankHelper,
    GetEmployeeBankHelper,
    GetEmployeeEducationHelper,
    AddEmployeeEducationHelper,
    UpdateEmployeeEducationHelper,
    DeleteEmployeeEducationHelper,
    GetEmployeeWorkExperienceHelper,
    AddEmployeeWorkExperienceHelper,
    UpdateEmployeeWorkExperienceHelper,
    DeleteEmployeeWorkExperienceHelper,
    GetEmployeePersonaleHelper,
    UpdateEmployeePersonaleHelper,
    AddEmployeePersonaleHelper,
    DeleteEmployeePersonaleHelper,
    GetEmployeeOtherPersonaleHelper,
    UpdateEmployeeOtherPersonaleHelper,
    GetEmployeeWorkDetailHelper,
    UpdateEmployeeWorkDetailHelper,
    AddEmployeeWorkDetailHelper,
    GetEmployeesHelper,
    GetEmployeePayrollDetailseHelper,
    UpdateEmployeePayrollDetailsHelper,
    GetAtsEmployeesHelper,
    GetEmployeeAddressHelper,
    UpdateEmployeeAddressHelper,
    GetEmployeesFaceHelper,
    GetEmployeePayrollProfileDetailHeper,
    UpdateEmployeePayrollProfileDetailHelper
} from '../../app/Components/Employee/helper/EmployeeHelper';
import * as ActionTypes from './ActionTypes';
import { AddVisitorsHelper, GetVisitorReasonsHelper, GetVisitorsDataHelper, GetVisitorsHelper, UpdateBulkVisitorsHelper, UpdateVisitorsHelper } from '../../app/Components/VisitorsManagement/helper/VisitorsManagementHelper';
import { AddVisitorManagementReasonHelper, DeleteVisitorManagementReasonHelper, GetVisitorManagementReasonHelper, UpdateVisitorManagementReasonHelper } from '../../app/Components/VisitorSettings/helper/Reason/ReasonHelper';
import { AddVisitorManagementRegionHelper, DeleteVisitorManagementRegionHelper, GetVisitorManagementRegionHelper, UpdateVisitorManagementRegionHelper } from '../../app/Components/VisitorSettings/helper/Region/RegionHelper';
import { GetVMExtraSettingConfigHelper, UpdateVMExtraSettingConfigHelper } from '../../app/Components/VisitorSettings/helper/CheckInFormConfig/CheckInFormConfigHelper';
import { AddManageGoalHelper, DeleteManageGoalHelper, GetManageGoalHelper, GetMyGoalHelper, UpdateManageGoalHelper } from '../../app/Components/Achievement Orchestrator/helpers/ManageGoalHelper';
import { AddPmsFeedbackHelper, DeletePmsFeedbackHelper, GetPmsFeedbackHelper, UpdatePmsFeedbackHelper } from '../../app/Components/Achievement Orchestrator/helpers/FeedbackHelper';
import { AddGoalSubtypeHelper, AddGoalTypeHelper, DeleteGoalSubtypeHelper, DeleteGoalTypeHelper, GetGoalSubtypeHelper, GetGoalTypeHelper, UpdateGoalSubtypeHelper, UpdateGoalTypeHelper } from '../../app/Components/PerformanceSettings/helper/GoalCategoryHelper';
import { AddECMSExitReasonHelper, DeleteECMSExitReasonHelper, GetECMSExitReasonHelper, UpdateECMSExitReasonHelper } from '../../app/Components/Ancillary/ECMS/helper/ExitReasonHelper';
import { AddECMSClearanceTypeHelper, DeleteECMSClearanceTypeHelper, GetECMSClearanceTypeHelper, UpdateECMSClearanceTypeHelper } from '../../app/Components/Ancillary/ECMS/helper/ClearanceHelper';
import { AddEmployeeClearanceHelper, DeleteEmployeeClearanceHelper, GetEmployeeClearanceHelper, UpdateEmployeeClearanceHelper } from '../../app/Components/ECMSystem/helper/EmployeeClearanceHelper';
import { GetReadOnlyExitEmployeesHelper } from '../../app/Components/ECMSystem/helper/AdminActionHelper';
import { AddPerformanceLogHelper, DeletePerformanceLogHelper, GetPerformanceLogHelper, UpdatePerformanceLogHelper } from '../../app/Components/Achievement Orchestrator/helpers/PerformanceHelper';
import { AddEmployeeTokenConfigHelper, DeleteEmployeeTokenConfigHelper, GetEmployeeTokenConfigHelper, UpdateEmployeeTokenConfigHelper } from '../../app/Components/CanteenManagement/helpers/TokenConfigHelper';
import { AddCanteenManagementRegionHelper, DeleteCanteenManagementRegionHelper, GetCanteenManagementRegionHelper, UpdateCanteenManagementRegionHelper } from '../../app/Components/CanteenSetting/helpers/CanteenRegionHelper';
import { DeleteVMMultipleOrgConfigurationHelper, GetVMMultipleOrgConfigurationHelper, GetVMOrgTypeHelper, UpdateVMOrgTypeHelper, UpsertVMMultipleOrgConfigurationHelper } from '../../app/Components/VisitorSettings/helper/OrgType/OrgTypeHelper';
import { DeleteVMPreRegistrationVisitorHelper, GetVMPreRegistrationVisitorHelper, UpsertVMPreRegistrationVisitorHelper } from '../../app/Components/VisitorsManagement/helper/PreRegistrationHelper';
import { AddEACUserHelper, GetEACUserHelper, UpdateEACUserHelper } from '../../app/Components/Employee/helper/CreateUserHelper';


// Employees
export function* GetEmployeesSaga(payload) {
    const response = yield call(GetEmployeesHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEES_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEES_GET_ERROR, payload: response })
    }
}

export function* GetEmployeesFaceSaga(payload) {
    const response = yield call(GetEmployeesFaceHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEES_FACE_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEES_FACE_GET_ERROR, payload: response })
    }
}

export function* GetAtsEmployeesSaga(payload) {
    const response = yield call(GetAtsEmployeesHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.ATS_EMPLOYEES_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.ATS_EMPLOYEES_GET_ERROR, payload: response })
    }
}

export function* GetEmployeeBasicSaga(payload) {
    const response = yield call(GetEmployeeBasicHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.GET_EMPLOYEE_BASIC_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.GET_EMPLOYEE_BASIC_ERROR, payload: response })
    }
}


export function* AddEmployeeBasicSaga(payload) {
    const response = yield call(AddEmployeeBasicHelper, payload.basicDetails)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.ADD_EMPLOYEE_BASIC_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.ADD_EMPLOYEE_BASIC_ERROR, payload: response })
    }
}

export function* UpdateEmployeeBasicSaga(payload) {
    const response = yield call(UpdateEmployeeBasicHelper, payload.basicDetails)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.UPDATE_EMPLOYEE_BASIC_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.UPDATE_EMPLOYEE_BASIC_ERROR, payload: response })
    }
}

export function* GetEmployeeFamilySaga(payload) {
    const response = yield call(GetEmployeeFamilyHelper, payload.familyData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_FAMILY_GET_SUCCESS, payload: response })
    }
    else {
        yield put({ type: ActionTypes.EMPLOYEE_FAMILY_GET_ERROR, payload: response })
    }
}

export function* AddEmployeeFamilySaga(payload) {
    const response = yield call(AddEmployeeFamilyHelper, payload.familyData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_FAMILY_ADD_SUCCESS, payload: response })
    }
    else {
        yield put({ type: ActionTypes.EMPLOYEE_FAMILY_ADD_ERROR, payload: response })
    }
}

export function* UpdateEmployeeFamilySaga(payload) {
    const response = yield call(UpdateEmployeeFamilyHelper, payload.familyData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_FAMILY_UPDATE_SUCCESS, payload: response })
    }
    else {
        yield put({ type: ActionTypes.EMPLOYEE_FAMILY_UPDATE_ERROR, payload: response })
    }
}

export function* DeleteEmployeeFamilySaga(payload) {
    const response = yield call(DeleteEmployeeFamilyHelper, payload.familyData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_FAMILY_DELETE_SUCCESS, payload: response })
    }
    else {
        yield put({ type: ActionTypes.EMPLOYEE_FAMILY_DELETE_ERROR, payload: response })
    }
}

export function* GetEmployeeBankSaga(payload) {
    const response = yield call(GetEmployeeBankHelper, payload.bankDetails)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.GET_EMPLOYEE_BANK_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.GET_EMPLOYEE_BANK_ERROR, payload: response })
    }
}

export function* AddEmployeeBankSaga(payload) {
    const response = yield call(AddEmployeeBankHelper, payload.bankDetails)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.ADD_EMPLOYEE_BANK_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.ADD_EMPLOYEE_BANK_ERROR, payload: response })
    }
}

export function* UpdateEmployeeBankSaga(payload) {
    const response = yield call(UpdateEmployeeBankHelper, payload.bankDetails)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.UPDATE_EMPLOYEE_BANK_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.UPDATE_EMPLOYEE_BANK_ERROR, payload: response })
    }
}

export function* DeleteEmployeeBankSaga(payload) {
    const response = yield call(DeleteEmployeeBankHelper, payload.bankDetails)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.DELETE_EMPLOYEE_BANK_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.DELETE_EMPLOYEE_BANK_ERROR, payload: response })
    }
}

export function* GetEmployeeEducationSaga(payload) {
    const response = yield call(GetEmployeeEducationHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_EDUCATION_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_EDUCATION_GET_ERROR, payload: response })
    }
}

export function* AddEmployeeEducationSaga(payload) {
    const response = yield call(AddEmployeeEducationHelper, payload.educationData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_EDUCATION_ADD_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_EDUCATION_ADD_ERROR, payload: response })
    }
}

export function* UpdateEmployeeEducationSaga(payload) {
    const response = yield call(UpdateEmployeeEducationHelper, payload.educationData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_EDUCATION_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_EDUCATION_UPDATE_ERROR, payload: response })
    }
}

export function* DeleteEmployeeEducationSaga(payload) {
    const response = yield call(DeleteEmployeeEducationHelper, payload.educationData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_EDUCATION_DELETE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_EDUCATION_DELETE_ERROR, payload: response })
    }
}
// Work Experience
export function* GetEmployeeWorkExperienceSaga(payload) {
    const response = yield call(GetEmployeeWorkExperienceHelper, payload.workExperienceData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_EXPERIENCE_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_EXPERIENCE_GET_ERROR, payload: response })
    }
}

export function* AddEmployeeWorkExperienceSaga(payload) {
    const response = yield call(AddEmployeeWorkExperienceHelper, payload.workExperienceData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_EXPERIENCE_ADD_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_EXPERIENCE_ADD_ERROR, payload: response })
    }
}

export function* UpdateEmployeeWorkExperienceSaga(payload) {
    const response = yield call(UpdateEmployeeWorkExperienceHelper, payload.workExperienceData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_EXPERIENCE_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_EXPERIENCE_UPDATE_ERROR, payload: response })
    }
}

export function* DeleteEmployeeWorkExperienceSaga(payload) {
    const response = yield call(DeleteEmployeeWorkExperienceHelper, payload.workExperienceData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_EXPERIENCE_DELETE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_EXPERIENCE_DELETE_ERROR, payload: response })
    }
}

// Work Detail
export function* GetEmployeeWorkDetailSaga(payload) {
    const response = yield call(GetEmployeeWorkDetailHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_DETAIL_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_DETAIL_GET_ERROR, payload: response })
    }
}


export function* AddEmployeeWorkDetailSaga(payload) {
    const response = yield call(AddEmployeeWorkDetailHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_DETAIL_ADD_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_DETAIL_ADD_ERROR, payload: response })
    }
}
export function* UpdateEmployeeWorkDetailSaga(payload) {
    const response = yield call(UpdateEmployeeWorkDetailHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_DETAIL_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_WORK_DETAIL_UPDATE_ERROR, payload: response })
    }
}

export function* GetEmployeePersonalSaga(payload) {
    const response = yield call(GetEmployeePersonaleHelper, payload.personalData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_PERSONAL_GET_SUCCESS, payload: response })
    }
}

export function* AddEmployeePersonalSaga(payload) {
    const response = yield call(AddEmployeePersonaleHelper, payload.personalData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_PERSONAL_ADD_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_PERSONAL_ADD_ERROR, payload: response })
    }
}

export function* UpdateEmployeePersonalSaga(payload) {
    const response = yield call(UpdateEmployeePersonaleHelper, payload.personalData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_PERSONAL_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_PERSONAL_UPDATE_ERROR, payload: response })
    }
}

export function* DeleteEmployeePersonalSaga(payload) {
    const response = yield call(DeleteEmployeePersonaleHelper, payload.personalData)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_PERSONAL_DELETE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_PERSONAL_DELETE_ERROR, payload: response })
    }
}

export function* GetEmployeeOtherPersonalSaga(payload) {
    const response = yield call(GetEmployeeOtherPersonaleHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_OTHER_PERSONAL_GET_SUCCESS, payload: response })
    }
}

export function* UpdateEmployeeOtherPersonalSaga(payload) {
    const response = yield call(UpdateEmployeeOtherPersonaleHelper, payload.personalDetails)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_OTHER_PERSONAL_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_OTHER_PERSONAL_UPDATE_ERROR, payload: response })
    }
}

export function* GetEmployeeAddressSaga(payload) {
    const response = yield call(GetEmployeeAddressHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_ADDRESS_GET_SUCCESS, payload: response })
    }
}

export function* UpdateEmployeeAddressSaga(payload) {
    const response = yield call(UpdateEmployeeAddressHelper, payload.addressDetails)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_ADDRESS_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_ADDRESS_UPDATE_ERROR, payload: response })
    }
}

export function* GetEmployeePayrollDetailsSaga(payload) {
    const response = yield call(GetEmployeePayrollDetailseHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.GET_EMPLOYEE_PAYROLL_DETAILS_SUCCESS, payload: response })
    }
}

export function* UpdateEmployeePayrollDetailsSaga(payload) {
    const response = yield call(UpdateEmployeePayrollDetailsHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.UPDATE_EMPLOYEE_PAYROLL_DETAILS_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.GET_EMPLOYEE_PAYROLL_DETAILS_ERROR, payload: response })
    }
}

// Payroll Profile Details
export function* GetEmployeePayrollProfileDetailSaga(payload) {
    const response = yield call(GetEmployeePayrollProfileDetailHeper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_PAYROLL_PROFILE_DETAIL_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_PAYROLL_PROFILE_DETAIL_GET_ERROR, payload: response })
    }
}

export function* UpdateEmployeePayrollProfileDetailSaga(payload) {
    const response = yield call(UpdateEmployeePayrollProfileDetailHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_PAYROLL_PROFILE_DETAIL_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_PAYROLL_PROFILE_DETAIL_UPDATE_ERROR, payload: response })
    }
}

// visitorsManagement 
export function* GetVisitorsSaga(payload) {
    const response = yield call(GetVisitorsHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.VISITORS_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.VISITORS_GET_ERROR, payload: response })
    }
}

export function* GetVisitorDataSaga(payload) {
    const response = yield call(GetVisitorsDataHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.VISITORS_DATA_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.VISITORS_DATA_GET_ERROR, payload: response })
    }
}
export function* AddVisitorsSaga({params,callback}) {
    const response = yield call(AddVisitorsHelper, params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.ADD_VISITORS_SUCCESS, payload: response })
        if (callback) callback(null, response);
    } else {
        yield put({ type: ActionTypes.ADD_VISITORS_ERROR, payload: response })
        if (callback) callback(response, null);
    }
}

export function* GetVisitorReasonsSaga(payload) {
    const response = yield call(GetVisitorReasonsHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.GET_VISITORS_REASON_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.GET_VISITORS_REASON_ERROR, payload: response })
    }
}

export function* UpdateVisitorSaga({params,callback}) {
    const response = yield call(UpdateVisitorsHelper, params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.UPDATE_VISITORS_SUCCESS, payload: response })
        if (callback) callback(null, response);
    } else {
        yield put({ type: ActionTypes.UPDATE_VISITORS_ERROR, payload: response })
        if (callback) callback(response, null);
    }
}
export function* UpdateBulkVisitorSaga({params,callback}) {
    const response = yield call(UpdateBulkVisitorsHelper, params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.UPDATE_BULK_VISITORS_SUCCESS, payload: response })
        if (callback) callback(null, response);
    } else {
        yield put({ type: ActionTypes.UPDATE_BULK_VISITORS_ERROR, payload: response })
        if (callback) callback(response, null);
    }
}

export function* GetVMExtraSettingConfig(payload) {
  const response = yield call(GetVMExtraSettingConfigHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VM_EXTRA_SETTING_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VM_EXTRA_SETTING_GET_ERROR, payload: response });
  }
}

export function* UpdateVMExtraSettingConfig(payload) {
  const response = yield call(UpdateVMExtraSettingConfigHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VM_EXTRA_SETTING_UPDATE_SUCCESS , payload: response });
  } else {
    yield put({ type: ActionTypes.VM_EXTRA_SETTING_UPDATE_ERROR , payload: response });
  }
}

export function* GetVisitorManagementReason(payload) {
  const response = yield call(GetVisitorManagementReasonHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REASON_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REASON_GET_ERROR, payload: response });
  }
}

export function* AddVisitorManagementReason(payload) {
  const response = yield call(AddVisitorManagementReasonHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REASON_ADD_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REASON_ADD_ERROR, payload: response });
  }
}

export function* UpdateVisitorManagementReason(payload) {
  const response = yield call(UpdateVisitorManagementReasonHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REASON_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REASON_UPDATE_ERROR, payload: response });
  }
}

export function* DeleteVisitorManagementReason(payload) {
  const response = yield call(DeleteVisitorManagementReasonHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REASON_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REASON_DELETE_ERROR, payload: response });
  }
}

// Visitor Management Region Sagas
export function* GetVisitorManagementRegion(payload) {
  const response = yield call(GetVisitorManagementRegionHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REGION_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REGION_GET_ERROR, payload: response });
  }
}

export function* AddVisitorManagementRegion(payload) {
  const response = yield call(AddVisitorManagementRegionHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REGION_ADD_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REGION_ADD_ERROR, payload: response });
  }
}

export function* UpdateVisitorManagementRegion(payload) {
  const response = yield call(UpdateVisitorManagementRegionHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REGION_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REGION_UPDATE_ERROR, payload: response });
  }
}

export function* DeleteVisitorManagementRegion(payload) {
  const response = yield call(DeleteVisitorManagementRegionHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REGION_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VISITOR_MANAGEMENT_REGION_DELETE_ERROR, payload: response });
  }
}

/// PMS
export function* GetMyGoal(payload) {
  const response = yield call(GetMyGoalHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.MY_GOAL_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.MY_GOAL_GET_ERROR, payload: response });
  }
}

export function* GetManageGoal(payload) {
  const response = yield call(GetManageGoalHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.MANAGE_GOAL_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.MANAGE_GOAL_GET_ERROR, payload: response });
  }
}

export function* AddManageGoal({params,callback}) {
  const response = yield call(AddManageGoalHelper, params);
  if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.MANAGE_GOAL_ADD_SUCCESS, payload: response });
        if (callback) callback(null, response);
  } else {
        yield put({ type: ActionTypes.MANAGE_GOAL_ADD_ERROR, payload: response });
        if (callback) callback(response, null);
  }
}


export function* UpdateManageGoal({params,callback}) {
  const response = yield call(UpdateManageGoalHelper, params);
  if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.MANAGE_GOAL_UPDATE_SUCCESS, payload: response });
        if (callback) callback(null, response);
  } else {
        yield put({ type: ActionTypes.MANAGE_GOAL_UPDATE_ERROR, payload: response });
        if (callback) callback(response, null);
  }
}

export function* DeleteManageGoal({params,callback}) {
  const response = yield call(DeleteManageGoalHelper, params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.MANAGE_GOAL_DELETE_SUCCESS, payload: response });
    if (callback) callback(null, response);
  } else {
    yield put({ type: ActionTypes.MANAGE_GOAL_DELETE_ERROR, payload: response });
    if (callback) callback(response, null);
  }
}

export function* GetPmsFeedback(payload) {
  const response = yield call(GetPmsFeedbackHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.PMS_FEEDBACK_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.PMS_FEEDBACK_GET_ERROR, payload: response });
  }
}

export function* AddPmsFeedback({ params, callback }) {
  const response = yield call(AddPmsFeedbackHelper, params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.PMS_FEEDBACK_ADD_SUCCESS, payload: response });
    if (callback) callback(null, response);
  } else {
    yield put({ type: ActionTypes.PMS_FEEDBACK_ADD_ERROR, payload: response });
    if (callback) callback(response, null);
  }
}

export function* UpdatePmsFeedback({ params, callback }) {
  const response = yield call(UpdatePmsFeedbackHelper, params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.PMS_FEEDBACK_UPDATE_SUCCESS, payload: response });
    if (callback) callback(null, response);
  } else {
    yield put({ type: ActionTypes.PMS_FEEDBACK_UPDATE_ERROR, payload: response });
    if (callback) callback(response, null);
  }
}

export function* DeletePmsFeedback(payload) {
  const response = yield call(DeletePmsFeedbackHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.PMS_FEEDBACK_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.PMS_FEEDBACK_DELETE_ERROR, payload: response });
  }
}
export function* GetGoalType(payload) {
  const response = yield call(GetGoalTypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.GOAL_TYPE_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.GOAL_TYPE_GET_ERROR, payload: response });
  }
}

export function* AddGoalType({params,callback}) {
  const response = yield call(AddGoalTypeHelper, params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.GOAL_TYPE_ADD_SUCCESS, payload: response });
    if (callback) callback(null, response);
  } else {
    yield put({ type: ActionTypes.GOAL_TYPE_ADD_ERROR, payload: response });
    if (callback) callback(response, null);
  }
}

export function* UpdateGoalType(payload) {
  const response = yield call(UpdateGoalTypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.GOAL_TYPE_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.GOAL_TYPE_UPDATE_ERROR, payload: response });
  }
}

export function* DeleteGoalType({params,callback}) {
  const response = yield call(DeleteGoalTypeHelper, params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.GOAL_TYPE_DELETE_SUCCESS, payload: response });
    if (callback) callback(null, response);
  } else {
    yield put({ type: ActionTypes.GOAL_TYPE_DELETE_ERROR, payload: response });
    if (callback) callback(response, null);
  }
}


export function* GetGoalSubtype(payload) {
  const response = yield call(GetGoalSubtypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.GOAL_SUBTYPE_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.GOAL_SUBTYPE_GET_ERROR, payload: response });
  }
}

export function* AddGoalSubtype(payload) {
  const response = yield call(AddGoalSubtypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.GOAL_SUBTYPE_ADD_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.GOAL_SUBTYPE_ADD_ERROR, payload: response });
  }
}

export function* UpdateGoalSubtype(payload) {
  const response = yield call(UpdateGoalSubtypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.GOAL_SUBTYPE_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.GOAL_SUBTYPE_UPDATE_ERROR, payload: response });
  }
}

export function* DeleteGoalSubtype(payload) {
  const response = yield call(DeleteGoalSubtypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.GOAL_SUBTYPE_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.GOAL_SUBTYPE_DELETE_ERROR, payload: response });
  }
}
// ECMS
export function* GetECMSExitReason(payload) {
  const response = yield call(GetECMSExitReasonHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.GET_ECMS_EXIT_REASON_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.GET_ECMS_EXIT_REASON_ERROR, payload: response });
  }
}

export function* AddECMSExitReason(payload) {
  const response = yield call(AddECMSExitReasonHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.ADD_ECMS_EXIT_REASON_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.ADD_ECMS_EXIT_REASON_ERROR, payload: response });
  }
}

export function* UpdateECMSExitReason(payload) {
  const response = yield call(UpdateECMSExitReasonHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.UPDATE_ECMS_EXIT_REASON_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.UPDATE_ECMS_EXIT_REASON_ERROR, payload: response });
  }
}

export function* DeleteECMSExitReason(payload) {
  const response = yield call(DeleteECMSExitReasonHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.DELETE_ECMS_EXIT_REASON_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.DELETE_ECMS_EXIT_REASON_ERROR, payload: response });
  }
}

export function* GetECMSClearanceType(payload) {
  const response = yield call(GetECMSClearanceTypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.GET_ECMS_CLEARANCE_TYPE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.GET_ECMS_CLEARANCE_TYPE_ERROR, payload: response });
  }
}

export function* AddECMSClearanceType(payload) {
  const response = yield call(AddECMSClearanceTypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.ADD_ECMS_CLEARANCE_TYPE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.ADD_ECMS_CLEARANCE_TYPE_ERROR, payload: response });
  }
}

export function* UpdateECMSClearanceType(payload) {
  const response = yield call(UpdateECMSClearanceTypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.UPDATE_ECMS_CLEARANCE_TYPE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.UPDATE_ECMS_CLEARANCE_TYPE_ERROR, payload: response });
  }
}

export function* DeleteECMSClearanceType(payload) {
  const response = yield call(DeleteECMSClearanceTypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.DELETE_ECMS_CLEARANCE_TYPE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.DELETE_ECMS_CLEARANCE_TYPE_ERROR, payload: response });
  }
}

export function* GetEmployeeClearance(payload) {
  const response = yield call(GetEmployeeClearanceHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_CLEARANCE_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_CLEARANCE_GET_ERROR, payload: response });
  }
}

export function* AddEmployeeClearance(payload) {
  const response = yield call(AddEmployeeClearanceHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_CLEARANCE_ADD_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_CLEARANCE_ADD_ERROR, payload: response });
  }
}

export function* UpdateEmployeeClearance(payload) {
  const response = yield call(UpdateEmployeeClearanceHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_CLEARANCE_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_CLEARANCE_UPDATE_ERROR, payload: response });
  }
}

// VM Org Type Sagas
export function* GetVMOrgTypeSaga(payload) {
  const response = yield call(GetVMOrgTypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VM_ORG_TYPE_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VM_ORG_TYPE_GET_ERROR, payload: response });
  }
}

export function* UpdateVMOrgTypeSaga(payload) {
  const response = yield call(UpdateVMOrgTypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VM_ORG_TYPE_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VM_ORG_TYPE_UPDATE_ERROR, payload: response });
  }
}

// VM Multiple Org Configuration Sagas
export function* GetVMMultipleOrgConfigurationSaga(payload) {
  const response = yield call(GetVMMultipleOrgConfigurationHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VM_MULTIPLE_ORG_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VM_MULTIPLE_ORG_GET_ERROR, payload: response });
  }
}

export function* UpsertVMMultipleOrgConfigurationSaga(payload) {
  const response = yield call(UpsertVMMultipleOrgConfigurationHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VM_MULTIPLE_ORG_UPSERT_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VM_MULTIPLE_ORG_UPSERT_ERROR, payload: response });
  }
}

export function* DeleteVMMultipleOrgConfigurationSaga(payload) {
  const response = yield call(DeleteVMMultipleOrgConfigurationHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VM_MULTIPLE_ORG_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VM_MULTIPLE_ORG_DELETE_ERROR, payload: response });
  }
}

// VM Pre-Registration Sagas
export function* GetVMPreRegistrationVisitorSaga(payload) {
  const response = yield call(GetVMPreRegistrationVisitorHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VM_PRE_REGISTRATION_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VM_PRE_REGISTRATION_GET_ERROR, payload: response });
  }
}

export function* UpsertVMPreRegistrationVisitorSaga({params, callback}) {
  const response = yield call(UpsertVMPreRegistrationVisitorHelper, params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VM_PRE_REGISTRATION_UPSERT_SUCCESS, payload: response });
    if (callback) callback(response, null);
  } else {
    yield put({ type: ActionTypes.VM_PRE_REGISTRATION_UPSERT_ERROR, payload: response });
    if (callback) callback(null, response);
  }
}

export function* DeleteVMPreRegistrationVisitorSaga(payload) {
  const response = yield call(DeleteVMPreRegistrationVisitorHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.VM_PRE_REGISTRATION_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.VM_PRE_REGISTRATION_DELETE_ERROR, payload: response });
  }
}

export function* DeleteEmployeeClearance(payload) {
  const response = yield call(DeleteEmployeeClearanceHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_CLEARANCE_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_CLEARANCE_DELETE_ERROR, payload: response });
  }
}

export function* GetAdminExitEmployee(payload) {
  const response = yield call(GetReadOnlyExitEmployeesHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.ECMS_ADMIN_EXIT_EMPLOYEE_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.ECMS_ADMIN_EXIT_EMPLOYEE_GET_ERROR, payload: response });
  }
}

export function* GetPerformanceLog(payload) {
  const response = yield call(GetPerformanceLogHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.PERFORMANCE_LOG_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.PERFORMANCE_LOG_GET_ERROR, payload: response });
  }
}

export function* AddPerformanceLog({params,callback}) {
  const response = yield call(AddPerformanceLogHelper, params);
  if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PERFORMANCE_LOG_ADD_SUCCESS, payload: response });
        if (callback) callback(null, response);
  } else {
        yield put({ type: ActionTypes.PERFORMANCE_LOG_ADD_ERROR, payload: response });
        if (callback) callback(response, null);
  }
}

export function* UpdatePerformanceLog({params,callback}) {
  const response = yield call(UpdatePerformanceLogHelper, params);
  if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PERFORMANCE_LOG_UPDATE_SUCCESS, payload: response });
        if (callback) callback(null, response);
  } else {
        yield put({ type: ActionTypes.PERFORMANCE_LOG_UPDATE_ERROR, payload: response });
        if (callback) callback(response, null);
  }
}

export function* DeletePerformanceLog(payload) {
  const response = yield call(DeletePerformanceLogHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.PERFORMANCE_LOG_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.PERFORMANCE_LOG_DELETE_ERROR, payload: response });
  }
}

export function* GetEmployeeTokenConfig(payload) {
  const response = yield call(GetEmployeeTokenConfigHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_CANTEEN_TOKEN_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_CANTEEN_TOKEN_GET_ERROR, payload: response });
  }
}

export function* AddEmployeeTokenConfig({params, callback}) {
  const response = yield call(AddEmployeeTokenConfigHelper, params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_CANTEEN_TOKEN_ADD_SUCCESS, payload: response });
    if (callback) callback(null, response);
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_CANTEEN_TOKEN_ADD_ERROR, payload: response });
    if (callback) callback(response, null);
  }
}

export function* UpdateEmployeeTokenConfig(payload) {
  const response = yield call(UpdateEmployeeTokenConfigHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_CANTEEN_TOKEN_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_CANTEEN_TOKEN_UPDATE_ERROR, payload: response });
  }
}

export function* DeleteEmployeeTokenConfig(payload) {
  const response = yield call(DeleteEmployeeTokenConfigHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_CANTEEN_TOKEN_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_CANTEEN_TOKEN_DELETE_ERROR, payload: response });
  }
}

// Canteen Management Region Sagas
export function* GetCanteenManagementRegion(payload) {
  const response = yield call(GetCanteenManagementRegionHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.CANTEEN_MANAGEMENT_REGION_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.CANTEEN_MANAGEMENT_REGION_GET_ERROR, payload: response });
  }
}

export function* AddCanteenManagementRegion(payload) {
  const response = yield call(AddCanteenManagementRegionHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.CANTEEN_MANAGEMENT_REGION_ADD_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.CANTEEN_MANAGEMENT_REGION_ADD_ERROR, payload: response });
  }
}

export function* UpdateCanteenManagementRegion(payload) {
  const response = yield call(UpdateCanteenManagementRegionHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.CANTEEN_MANAGEMENT_REGION_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.CANTEEN_MANAGEMENT_REGION_UPDATE_ERROR, payload: response });
  }
}

export function* DeleteCanteenManagementRegion(payload) {
  const response = yield call(DeleteCanteenManagementRegionHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.CANTEEN_MANAGEMENT_REGION_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.CANTEEN_MANAGEMENT_REGION_DELETE_ERROR, payload: response });
  }
}

export function* GetEACUser(payload) {
  const response = yield call(GetEACUserHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.GET_EAC_USER_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.GET_EAC_USER_ERROR, payload: response });
  }
}

export function* AddEACUser({params,callback}) {
  const response = yield call(AddEACUserHelper, params);
  if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.ADD_EAC_USER_SUCCESS, payload: response });
        if (callback) callback(response, null);
      } else {
        yield put({ type: ActionTypes.ADD_EAC_USER_ERROR, payload: response });
        if (callback) callback(null, response);
  }
}


export function* UpdateEACUsers({params,callback}) {
  const response = yield call(UpdateEACUserHelper, params);
  if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.UPDATE_EAC_USER_SUCCESS, payload: response });
        if (callback) callback(response, null);
      } else {
        yield put({ type: ActionTypes.UPDATE_EAC_USER_ERROR, payload: response });
        if (callback) callback(null, response);
  }
}